import React, { Component } from 'react';

import styles from '../add-edit-product.scss';

const statusContent = {
	BRANDED_LOG: {
		statusTitle: 'Information Updated By Seller',
		statusDesc: 'Following Information is Updated'
	},
	DOCUMENT_PENDING: {
		statusTitle: 'Document Upload Pending',
		statusDesc:
			'One of the following document(s) needs to be uploaded and verified for this product to go live',
		statusClass: 'document-pending',
		titleClass: 'warning-status'
	},
	REJECTED: {
		statusTitle: 'Product Rejected',
		statusDesc:
			'This product has been rejected because of the following reason(s)'
	},
	REJECTED_SERVICE: {
		statusTitle: 'Service Rejected',
		statusDesc:
		  'This service has been rejected because of the following reason(s)'
	},
	AUDIT_PENDING: {
		statusTitle: 'Audit Pending',
		statusDesc:
			'Your product will be reviewed by our moderation team within 72 hours before it goes live.',
		statusClass: 'audit-pending',
		titleClass: 'warning-status'
	},
	INVENTORY_AUDIT_PENDING: {
		statusTitle: 'Inventory Audit Pending',
		statusDesc:
			'Your product inventory details will be reviewed by our moderation team within 72 hours before it goes live.',
		statusClass: 'audit-pending',
		titleClass: 'warning-status'
	},
	AWAITING_INVENTORY_COMPLIANCE: {
		statusTitle: 'Awaiting Inventory Compliance',
		statusDesc:
			'Your product inventory details needs to be in compliance with government regulation before it goes live. Please check inventory compliance tab for more details.',
		statusClass: 'audit-pending',
		titleClass: 'warning-status'
	}

};

const StatusMessages = ({ status, reasons, type = 'product' }) => {
	let containerClass = statusContent[status]?.statusClass || '';
	let titleClass = statusContent[status]?.titleClass || '';
	let title = statusContent[status]?.statusTitle || '';
	let statusDesc = statusContent[status]?.statusDesc || '';

	return (
		<div
			className={`${styles['rejected-product-container']} ${styles[containerClass]}`}
		>
			<div className={`${styles['pending-text']} ${styles[titleClass]}`}>
				<i className='icon-Info'></i>
				<div>
					<div className={styles['pending-status']}>{title}</div>
					<div className={`${styles['rejection-message']}`}>
						{statusDesc}
					</div>
					{reasons?.map((item, index) => {
						return (
							<div
								key={index}
								className={`${styles['auditor-message']}`}
							>
								<div>
									<span
										className={`${styles['bullet-market']}`}
									></span>
								</div>
								<div
									className={`${styles['rejection-reason']}`}
								>
									{item}
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};

export default StatusMessages;
